export default {
  title: '邀请应聘登记',
  label: {
    questionnaire: '应聘登记表',
    emailTemplate: '邮件模板'
  },
  message: {
    inviteSuccess: '邀请发送成功',
    inviteFail: '邀请发送失败'
  }
}
